/**
 * Company-wide constants.
 * Update these values here to propagate them throughout the entire codebase,
 * including markdown files (which use {{COMPANY_PHONE}} / {{COMPANY_PHONE_TEL}} tokens).
 */

/** Main company phone number (display format, international). */
export const COMPANY_PHONE = '+1870 455 6742';

/** Display phone number without country code, used in UI labels. */
export const COMPANY_PHONE_DISPLAY = '1870 455 6742';

/** International display format with dashes, used in anchor text. */
export const COMPANY_PHONE_FORMATTED = '+1-870-455-6742';

/** Digits-only E.164 format used for tel: href attributes. */
export const COMPANY_PHONE_RAW = '+18704556742';

/** Ready-to-use tel: link. */
export const COMPANY_PHONE_TEL = `tel:${COMPANY_PHONE_RAW}`;

export const COMPANY_EMAIL = "info@ratesautotransport.com";

/** Garlas LLC operational contact email (different from COMPANY_EMAIL). */
export const GARLAS_EMAIL = 'garlas.llc@gmail.com';
